﻿(() => {
  if (window.__homeCollectionCardsScriptLoaded) return;
  window.__homeCollectionCardsScriptLoaded = true;

  const sectionSelector = '[data-home-collection-cards]';

  const getScrollAmount = (track, pageSize) => {
    const firstItem = track.querySelector('.home-collection-cards__item');
    if (!firstItem) return track.clientWidth;

    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const itemWidth = firstItem.getBoundingClientRect().width;

    return Math.max(track.clientWidth, itemWidth * pageSize + gap * (pageSize - 1));
  };

  const updateButtons = (section) => {
    const track = section.querySelector('[data-home-collection-cards-track]');
    const prev = section.querySelector('[data-home-collection-cards-prev]');
    const next = section.querySelector('[data-home-collection-cards-next]');

    if (!track || !prev || !next) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= maxScroll - 1;
  };

  const initSection = (section) => {
    if (!section || section.dataset.homeCollectionCardsInitialized === 'true') return;

    const track = section.querySelector('[data-home-collection-cards-track]');
    const prev = section.querySelector('[data-home-collection-cards-prev]');
    const next = section.querySelector('[data-home-collection-cards-next]');
    const pageSize = parseInt(section.dataset.pageSize || '6', 10);

    if (!track) return;

    section.dataset.homeCollectionCardsInitialized = 'true';

    const scrollByPage = (direction) => {
      const amount = getScrollAmount(track, pageSize) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    };

    if (prev && next) {
      prev.addEventListener('click', () => scrollByPage(-1));
      next.addEventListener('click', () => scrollByPage(1));
      track.addEventListener('scroll', () => window.requestAnimationFrame(() => updateButtons(section)), { passive: true });
      window.addEventListener('resize', () => updateButtons(section));
      updateButtons(section);
    }
  };

  const initAll = (root = document) => {
    root.querySelectorAll(sectionSelector).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();


